import React from 'react';
import PropTypes from 'prop-types';
import { minBy, maxBy, last as _last } from 'lodash';

var SvgContextMixin = require('./svgContextMixin'),
  SvgChartContextMixin = require('./svgChartContextMixin');

var SvgChartPolyLine = require('./chartPolyline'),
  SvgChartPoint = require('./chartPoint');

var SvgChartLine = React.createClass({
  mixins: [SvgContextMixin, SvgChartContextMixin],

  statics: {
    id: "LineChart-"
  },

  propTypes: {
    chartId: PropTypes.number.isRequired,
    data: PropTypes.array.isRequired,
    iconUrl: PropTypes.string,
    color: PropTypes.string,
    onPointEnter: PropTypes.func,
    onPointLeave: PropTypes.func
  },

  getDefaultProps(){
    return {
      color: "#000000"
    };
  },

  render(){
    var {chartId, data} = this.props;
    var points = this._createDataSet(data);

    return (
      <g id={SvgChartLine.id + chartId} onMouseEnter={this.props.onMouseEnter}>
        {this._getPolyLine(points)}
        {this._getPoints(points)}
      </g>
    );
  },

  _createDataSet(data){
    var self = this;
    return data.map((dataPoint) => (self.context.getPoint(dataPoint.x, dataPoint.y)));
  },

  _getPolyLine(points){
    if (points.length < 2) return null;

    var {data, chartId, color, iconUrl} = this.props;
    if (!data || !data.length) return null;

    var min = minBy(data, (point) => (point.y)),
      max = maxBy(data, (point) => (point.y)),
      last = _last(data),
      iconCenter = this.context.getPoint(last.x, (min.y + max.y) / 2);

    return (
      <SvgChartPolyLine
        id={ chartId }
        points={ points.map((point) => (point.join(","))).join(" ") }
        stroke={ color }
        iconUrl={ iconUrl }
        iconCenter={iconCenter}
      />
    );
  },

  _getPoints(points){
    var {color} = this.props;
    return points.map(
      (point, index) => (
        <SvgChartPoint
          key={index}
          x={point[0]} y={point[1]}
          size={2.2}
          color={color}
          onMouseEnter={this.onPointEnter.bind(null, index)}
          onMouseLeave={this.props.onPointLeave}

        />
      )
    )
  },

  onPointEnter(pointId, event){
    var {onPointEnter, chartId} = this.props;

    if (onPointEnter) {
      onPointEnter(chartId, pointId, event);
    }
  }

});


module.exports = SvgChartLine;
